import { useNavigation } from '@refinedev/core';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';

export type SaSmsSection = 'tenants' | 'approvals' | 'migrations' | 'settings';

const PATHS: Record<SaSmsSection, string> = {
    tenants: '/sms-messaging',
    approvals: '/sms-messaging/approvals',
    migrations: '/sms-messaging/number-migrations',
    settings: '/sms-messaging/settings',
};

/** Section tabs shared by the console pages. */
export const SaSmsNav: React.FC<{ active: SaSmsSection }> = ({ active }) => {
    const { t } = useTranslation(['sa-sms']);
    const { push } = useNavigation();
    return (
        <Tabs
            activeKey={active}
            onChange={(key) => push(PATHS[key as SaSmsSection])}
            items={(Object.keys(PATHS) as SaSmsSection[]).map((key) => ({
                key,
                label: t(`nav.${key}`),
            }))}
        />
    );
};
